import { Bug, FileText, Calculator, ShieldCheck, Clipboard, CalendarDays, Palette, AlertTriangle } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const PestControlIndustry = () => (
  <IndustryPlaceholderPage
    name="Pest Control"
    fullySupported={false}
    icon={Bug}
    iconColor="text-warning"
    iconBg="bg-[hsl(var(--warning)/0.1)]"
    headline="Pest Control Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps pest control companies create professional service proposals, treatment plans, and recurring service contracts — all from one platform."
    valueProps={[
      { title: "Close More Accounts", description: "Build detailed pest control proposals with treatment plans, inspection reports, and pricing that win residential and commercial clients." },
      { title: "Streamline Operations", description: "Generate branded proposals with treatment schedules, product details, and safety documentation in minutes." },
      { title: "Built for Pest Control", description: "Industry-specific templates for termite, rodent, mosquito, bed bug, and general pest management — designed by professionals." },
    ]}
    features={[
      { icon: Calculator, label: "Treatment Cost Calculators" },
      { icon: CalendarDays, label: "Service Scheduling" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: ShieldCheck, label: "Safety Documentation" },
      { icon: Bug, label: "Pest-Specific Templates" },
      { icon: Clipboard, label: "Inspection Reports" },
      { icon: Palette, label: "Custom Branding" },
      { icon: AlertTriangle, label: "Risk Assessments" },
    ]}
    benefits={[
      "Create property-specific proposals with pest identification, treatment methods, and schedules",
      "Auto-calculate costs based on property size, pest type, and treatment frequency",
      "Generate branded proposals with inspection photos and safety documentation",
      "Send contracts with digital signatures for fast client approval",
      "Track service agreements, recurring treatments, and renewal dates",
      "Support one-time treatments and recurring pest management plans",
    ]}
    proposalTemplates={[
      "Residential Pest Control",
      "Commercial Pest Management",
      "Termite Treatment & Prevention",
      "Mosquito & Outdoor Pest Control",
      "Bed Bug Treatment Program",
    ]}
    contractTemplates={[
      "Recurring Pest Control Agreement",
      "One-Time Treatment Contract",
      "Commercial Pest Management Contract",
      "Termite Protection Plan",
    ]}
    faq={[
      { q: "What is Sentinel Forge for pest control?", a: "Sentinel Forge is a proposal and contract platform tailored for pest control companies. It helps you build treatment proposals, calculate service costs, and send digital contracts to clients." },
      { q: "Can I create proposals for different pest types?", a: "Yes. The platform includes templates for general pests, termites, mosquitoes, bed bugs, rodents, and more — each with pest-specific treatment plans." },
      { q: "How does treatment pricing work?", a: "You define property size, pest type, treatment method, and frequency. The system automatically calculates total and recurring treatment costs." },
      { q: "Can I manage recurring service contracts?", a: "Yes. You can create monthly, quarterly, or annual pest management agreements with automatic renewal and scheduling templates." },
      { q: "Do clients need an account to sign contracts?", a: "No. Clients receive a secure link to review and digitally sign contracts without creating an account." },
      { q: "Can I add my company's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will pest control be available?", a: "We're building it now. Join the waitlist to get notified when the pest control module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to modernize your pest control business?"
    ctaDescription="Join pest control companies preparing to automate proposals and client contracts with Sentinel Forge."
  />
);

export default PestControlIndustry;
